module.exports = __webpack_public_path__ + "img/04.fb65f90d.jpg";